/**
 * @aiPurpose derive a non-empty short text mark for a carrier badge — trimmed
 *   `code` when present, otherwise up-to-2-character initials from `name`,
 *   with `?` as a defensive last-resort fallback.
 * @aiInvariant return value is always a non-empty string. Initials mirror the
 *   `Avatar` component split rule (whitespace/dot tokens, first character of
 *   the first two non-empty tokens, uppercased) so single-token names like
 *   `DHL` produce one letter (`D`) by design — smarter acronyms and
 *   legal-prefix filtering are explicit non-goals here.
 */
export function carrierMarkText(name: string, code?: string): string {
  const trimmedCode = code?.trim();
  if (trimmedCode) return trimmedCode;

  const initials = name
    .split(/[\s.]+/)
    .filter(Boolean)
    .map((token) => token[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return initials || '?';
}
